import { checkJapanese } from "../../lib";
import moment from 'moment'

export function convertToCsv(metadata, transcriptions) {
  const csvData = [
    [],
    [checkJapanese() ? "部屋名" : "Room name", metadata.channel_id.split('.')[1]],
    [checkJapanese() ? "日時" : "Date and Time", moment.unix(metadata.recording_started_at).format('YYYY-MM-DD HH:mm')],
    [checkJapanese() ? "録画時間" : "Recording Time", getRecordingTime(metadata.recording_started_at, metadata.recording_ended_at).toString()],
    ["", ""],
    [checkJapanese() ? "時間" : "Time Stamp", checkJapanese() ? "内容" : "Text"]
  ];
  transcriptions.forEach(result => {
    csvData.push(
      [moment(result.timestamp).format('HH:mm:ss'), result.transcript]
    )
  })
  return csvData;
}

function getRecordingTime(startTime, endTime) {
  const duration = moment.duration(moment.unix(endTime).diff(moment.unix(startTime)));
  return secondsToTime(duration.asSeconds());
}

function secondsToTime(secs)
{
    const hours = Math.floor(secs / (60 * 60));
   
    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);
 
    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);
   return `${hours}:${minutes.toString().length === 1 ? '0' + minutes : minutes}:${seconds}`
}


// WEBPACK FOOTER //
// src/routes/Transcriptions/convertToCsv.js